import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Result, Spin, Layout, Card } from 'antd';
import './QrLookup.css';
import QueueAnim from 'rc-queue-anim';
import RiskWarning from './RiskWarning';

function QrLookup() {
    const { number } = useParams();
    const navigate = useNavigate();
    const location = useLocation(); // 使用 useLocation 钩子
    const [result, setResult] = useState(null);
    const [timestamp, setTimestamp] = useState(null);
    const [loading, setLoading] = useState(true);
    const [resultMessage, setResultMessage] = useState('');
    const [checkTimes, setCheckTimes] = useState(0);
    const [resultTitle, setResultTitle] = useState();
    const [resultStatus, setResultStatus] = useState();
    
    // 获取查询参数
    const queryParams = new URLSearchParams(location.search);
    const queryNumber = queryParams.get('i'); // 获取查询参数 i 的值

    useEffect(() => {
        const fetchData = async () => {
            try {
                // 使用查询参数构建请求 URL
                const response = await fetch(`http://check.harscorail.com.cn:8086/qrcode/${queryNumber || number}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                if (data["serialCode"] !== "0000000000000000") {
                    setResult(true);
                    const originalTimestamp = data["lastQueryTime"];
                    const times = data["checkTimes"];
                    const adjustedTimestamp = new Date(originalTimestamp).getTime();
                    const adjustedDate = new Date(adjustedTimestamp).toLocaleString();
                    setTimestamp(adjustedDate);
                    setCheckTimes(times);
                    
                    if (checkTimes === 0) {
                        setResultTitle("查询成功");
                        setResultStatus("success");
                        setResultMessage("您所查询的序列码存在，这是第一次查询");
                    } else {
                        setResultStatus("warning");
                        setResultTitle("风险提示");
                    }
                } else {
                    setResult(false);
                    setResultMessage("您所查询的序列码不存在");
                }
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [queryNumber, number]); // 依赖于 queryNumber 和 number

    useEffect(() => {
        if (checkTimes >= 1 && result) {
            setResultStatus("warning");
            setResultTitle("风险提示");
            const resultMessage = (
                <>
                    您所查询的序列码存在, 这是第<strong>{checkTimes + 1}</strong>次查询, 上次查询时间 <strong>{timestamp}</strong><br />
                    该序列码已经被多次查询，请注意甄别风险
                </>
            );
            setResultMessage(resultMessage);
        } else if (result && checkTimes === 0) {
            setResultStatus("success");
            setResultMessage("您所查询的序列码存在，这是第一次查询");
        } else if (!result) {
            setResultTitle("查询失败");
            setResultStatus("error");
        }
    }, [checkTimes, result, timestamp]);

    return (
        <div className="container">
            <Card title={<div className="card-title">产品防伪查询</div>} className="lookup-card"
                style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            >
                {loading ? (
                    <div className="loading-container">
                        <Spin size="large" />
                    </div>
                ) : (
                    <QueueAnim delay={200} className="queue-simple">
                        <Result
                            status={resultStatus}
                            title={resultTitle}
                            subTitle={<span style={{ whiteSpace: 'pre-line' }}>{resultMessage}</span>}
                        />
                    </QueueAnim>
                )}
            </Card>
            <QueueAnim delay={200} className="queue-simple">
                {result != null && <RiskWarning />}
            </QueueAnim>
        </div>
    );
}

export default QrLookup;